import { Path } from "../../svg/Path";
import type { Seg } from "../../svg/Seg";
import { Circle } from "../../svg/Circle";
import type { PlotProps } from "./Plot";

const PlotCrossCircles = (props: PlotProps) => {
    const { xc, yc, tvar, atIndex, options, } = props;

    const r = Math.max(Math.floor((xc.wBar - 2) / 2), 3);
    const d = r * 2
    //const strokeWidth = undefined// options.linewidth || 1


    function plot() {
        const segs = plotLine();

        return { segs }
    }

    function plotLine(): Seg[] {
        const path = new Path()
        const segs: Seg[] = [path]

        let y1: number // for prev
        let y2: number // for curr

        // For those need connect from one bar to the next, use bar++ instead of 
        // bar += xc.nBarsCompressed to avoid uncontinuted line.
        for (let bar = 1; bar <= xc.nBars; bar += xc.nBarsCompressed) {
            // use `undefined` to test if value has been set at least one time
            const vs: number[] = []
            for (let i = 0; i < xc.nBarsCompressed; i++) {
                const time = xc.tb(bar + i)
                if (tvar.occurred(time)) {
                    const datas = tvar.getByTime(time);
                    const data = datas ? datas[atIndex] : undefined;
                    const v = data ? data.value : NaN
                    if (typeof v === "number" && !isNaN(v)) {
                        vs.push(v)
                    }
                }
            }

            for (const value of vs) {
                if (value !== undefined && !isNaN(value)) {
                    y2 = yc.yv(value)
                    // x1 shoud be decided here, it may not equal prev x2:
                    // think about the case of on calendar day mode
                    const x1 = xc.xb(bar - xc.nBarsCompressed)
                    const x2 = xc.xb(bar)

                    switch (options.style) {
                        case 'style_circles':
                            segs.push(new Circle(x2, y2, r));

                            break

                        case 'style_cross':
                            path.moveto(x2, y2 - d)
                                .lineto(x2, y2)
                                .moveto(x2 - r, y2 - r)
                                .lineto(x2 + r, y2 - r);

                            break
                    }

                    y1 = y2;
                }
            }
        }

        return segs
    }

    const { segs } = plot();

    return (
        segs.map((seg, n) => seg.render({ key: 'seg-' + n, style: { stroke: options.color, fill: 'none' } }))
    )
}

export default PlotCrossCircles;